import React from "react"
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import {FormControlLabel, Typography} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import InfoIconComponent from "./InfoIcon";
import PersistIfValidationOrFilterFailDocs from "../../documentation/PersistIfValidationOrFilterFailDocs";

export default function PersistTradePlanIfValidationFilterFailComponent({top, dispatchTop}) {
    return (
        <FormControl component="fieldset">
            <FormControlLabel
                control={
                    <Checkbox
                        checked={top.persistTradePlanOnFailedFiltersOrValidation}
                        onChange={(ev) =>
                            dispatchTop({
                                persistTradePlanOnFailedFiltersOrValidation: ev.target.checked,
                            })
                        }
                        name="persistTradePlanOnFailedFiltersOrValidation"
                    />
                }
                label={
                    <Typography style={{fontSize: 12}}>
                        {" "}
                        <InfoIconComponent
                            docs={PersistIfValidationOrFilterFailDocs}
                        />
                        persist if validation/filter fail
                    </Typography>
                }
            />
        </FormControl>);
}